import { lazyRouteComponent } from "@tanstack/react-router";
import { Landmark } from "lucide-react";

import type { PageDef } from "@/app/registry";

export const FII_PERIODS = ["1m", "3m", "6m", "1y", "3y", "5y"] as const;
export type FiiPeriodParam = (typeof FII_PERIODS)[number];

export interface FiiSearch {
  /** FII vs NIFTY window (default 6 months). */
  period: FiiPeriodParam;
  /** FII vs NIFTY measure: net contracts or long share. */
  m: "net" | "long";
}

export function parseFiiSearch(s: Record<string, unknown>): FiiSearch {
  return {
    period: FII_PERIODS.includes(s.period as FiiPeriodParam) ? (s.period as FiiPeriodParam) : "6m",
    m: s.m === "long" ? "long" : "net",
  };
}

export const pages: PageDef[] = [
  {
    path: "/app/fii",
    title: "FII / DII",
    component: lazyRouteComponent(() => import("./FiiPage"), "FiiPage"),
    nav: { label: "FII / DII", icon: Landmark, group: "Markets", order: 45 },
    validateSearch: parseFiiSearch,
  },
];
